import React from 'react'
import footerStyle from '../Footer/footer.module.css'

class Footer extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const path = this.props.pathname ? this.props.pathname.split('/')[1] : false

    const langPath = path
      ? path == 'en-CA'
        ? true
        : path == 'board'
        ? true
        : false
      : true
    return (
      <div className={footerStyle.footer}>
        <div className="container ">
          {langPath ? (
            <div className={footerStyle.flexMe}>
              <div>
                <h5>
                  <strong>THE CANADIAN REAL ESTATE ASSOCIATION</strong>
                </h5>
              </div>
              <div>
                <strong>Phone</strong>
                :613.237-7111 &nbsp; &nbsp;
                <strong>Email:</strong>
                <a href="#">info@crea.ca</a>
              </div>
              <div c className={footerStyle.col1}>
                <a
                  href="https://www.facebook.com/CREA.ACI"
                  target="_blank"
                  id="icon_facebook"
                  alt="CREA's Facebook page"
                  title="CREA's Facebook page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_facebook.png')}
                    alt="CREA's Facebook page"
                    title="CREA's Facebook page"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/1400987"
                  target="_blank"
                  id="icon_linkedin"
                  alt="CREA's LinkedIn page"
                  title="CREA's LinkedIn page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_linkedin.png')}
                    alt="CREA's LinkedIn page"
                    title="CREA's LinkedIn page"
                  />
                </a>
                <a
                  href="https://twitter.com/CREA_ACI"
                  target="_blank"
                  id="icon_twitter"
                  alt="CREA's Twitter page"
                  title="CREA's Twitter page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_twitter.png')}
                    alt="CREA's Twitter page"
                    title="CREA's Twitter page"
                  />
                </a>
                <a
                  href="https://www.youtube.com/user/CREACHANNEL"
                  target="_blank"
                  id="icon_youtube"
                  alt="CREA's YouTube page"
                  title="CREA's YouTube page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_youtube.png')}
                    alt="CREA's YouTube page"
                    title="CREA's YouTube page"
                  />
                </a>
                <a
                  href="https://www.instagram.com/crea_aci/"
                  target="_blank"
                  id="icon_instagram"
                  alt="CREA's Instagram page"
                  title="CREA's Instagram page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_instagram.png')}
                    alt="CREA's Instagram page"
                    title="CREA's Instagram page"
                  />
                </a>
                <a
                  href="http://www.crea.ca/feed/?post_type=crea_newsroom"
                  target="_blank"
                  id="icon_rss"
                  alt="CREA's RSS Feed"
                  title="CREA's RSS Feed"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_rss.png')}
                    alt="CREA's RSS Feed"
                    title="CREA's RSS Feed"
                  />
                </a>
              </div>
            </div>
          ) : (
            <div className={footerStyle.flexMe}>
              <div>
                <h5>
                  <strong>L’ASSOCIATION CANADIENNE DE L’IMMOBILIER</strong>
                </h5>
              </div>
              <div>
                <strong>Téléphone&nbsp;</strong> : 613-237-7111 &nbsp; &nbsp;
                <strong>courriel&nbsp; : </strong>
                <a href="#">info@crea.ca</a>
              </div>
              <div className={footerStyle.col1}>
                <a
                  href="https://www.facebook.com/CREA.ACI"
                  target="_blank"
                  id="icon_facebook"
                  alt="CREA's Facebook page"
                  title="CREA's Facebook page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_facebook.png')}
                    alt="CREA's Facebook page"
                    title="CREA's Facebook page"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/1400987"
                  target="_blank"
                  id="icon_linkedin"
                  alt="CREA's LinkedIn page"
                  title="CREA's LinkedIn page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_linkedin.png')}
                    alt="CREA's LinkedIn page"
                    title="CREA's LinkedIn page"
                  />
                </a>
                <a
                  href="https://twitter.com/CREA_ACI"
                  target="_blank"
                  id="icon_twitter"
                  alt="CREA's Twitter page"
                  title="CREA's Twitter page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_twitter.png')}
                    alt="CREA's Twitter page"
                    title="CREA's Twitter page"
                  />
                </a>
                <a
                  href="https://www.youtube.com/user/CREACHANNEL"
                  target="_blank"
                  id="icon_youtube"
                  alt="CREA's YouTube page"
                  title="CREA's YouTube page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_youtube.png')}
                    alt="CREA's YouTube page"
                    title="CREA's YouTube page"
                  />
                </a>
                <a
                  href="https://www.instagram.com/crea_aci/"
                  target="_blank"
                  id="icon_instagram"
                  alt="CREA's Instagram page"
                  title="CREA's Instagram page"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_instagram.png')}
                    alt="CREA's Instagram page"
                    title="CREA's Instagram page"
                  />
                </a>
                <a
                  href="http://www.crea.ca/feed/?post_type=crea_newsroom"
                  target="_blank"
                  id="icon_rss"
                  alt="CREA's RSS Feed"
                  title="CREA's RSS Feed"
                  rel="noopener"
                >
                  <img
                    src={require('../../images/icon_rss.png')}
                    alt="CREA's RSS Feed"
                    title="CREA's RSS Feed"
                  />
                </a>
              </div>
            </div>
          )}
        </div>
        <hr />
        {langPath ? (
          <div className="row row-2">
            <div className={footerStyle.logo}>
              <div className="col">
                {/* <img src={require('../../images/logo_crea_EN.svg')} /> */}
                <a href="#" title="CREA Logo" alt="CREA Logo">
                  <div className="CREA_Footer_Dark_Logo_EN" />
                  <div className="CREA_Footer_Light_Logo_EN" />
                </a>
              </div>
            </div>
            <div className="col ">
              <p className={footerStyle.Trademark}>
                The trademarks MLS®, Multiple Listing Service® and the
                associated logos are owned by The Canadian Real Estate
                Association (CREA) and identify the quality of services provided
                by real estate professionals who are members of CREA. The
                trademarks REALTOR®, REALTORS® and the REALTOR® logo are
                controlled by CREA and identify real estate professionals who
                are members of CREA.{' '}
                <a href="https://www.crea.ca/legal/" alt="Legal" title="Legal">
                  Legal
                </a>{' '}
                |
                <a
                  href="https://www.crea.ca/privacy/"
                  alt="Privacy"
                  title="Privacy"
                >
                  Privacy
                </a>
              </p>
            </div>
          </div>
        ) : (
          <div className="row row-2">
            <div className={footerStyle.logoFR}>
              <div className="col">
                {/* <img src={require('../../images/ACI_Logo.png')} /> */}
                <div className="CREA_Footer_Dark_Logo_FR" />
                <div className="CREA_Footer_Light_Logo_FR" />
              </div>
            </div>
            <div className="col">
              <p className={footerStyle.Trademark}>
                Les marques de commerce MLS® et Multiple Listing Service® ainsi
                que les logos connexes sont la propriété de L’Association
                canadienne de l’immobilier (ACI) et ils mettent en valeur la
                qualité des services qu’offrent les courtiers et agents
                immobiliers exerçant la profession à titre de membres de l’ACI.
                Les marques de commerce REALTOR® et REALTORS®, de même que le
                logo REALTOR®, sont sous le contrôle de L’Association canadienne
                de l’immobilier (ACI) et désignent les professionnels de
                l’immobilier qui sont membres de l’ACI.
                <br />
                <a
                  href="https://www.crea.ca/fr/legal/"
                  alt="Legal"
                  title="Renseignements juridiques"
                >
                  Renseignements juridiques
                </a>
                |{' '}
                <a
                  href="https://www.crea.ca/fr/privacy/"
                  alt="Legal"
                  title="Confidentialité Web"
                >
                  Confidentialité Web
                </a>
              </p>
            </div>
          </div>
        )}
      </div>
    )
  }
}
export default Footer
